import React from "react";

const FilterContext = React.createContext(null)

export default FilterContext